/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Remove_FileInputs */



/**
* | output |
* | --- |
* | "Remove file" |
*
* @param {Embed_Captions_Remove_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_remove_file = /** @type {((inputs?: Embed_Captions_Remove_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Remove_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить файл")
	if (locale === "es") return /** @type {LocalizedString} */ ("Quitar archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover ficheiro")
	return /** @type {LocalizedString} */ ("Remove file")
});